import { useEffect, useState } from "react";
import "./About.css";
import Hero from "./hero/Hero";
import Services from "./service/Service";
import Development from "./development/Development";
import People from "./people/People";
import CEO from "./ceo/CEO";
import AboutSEO from "../../components/SEO/AboutSEO";

import { getServices, getTeam } from "../../api/about";
import { getContact } from "../../api/contact";

const About = () => {
  const [isMobile, setIsMobile] = useState(window.screen.width < 768);
  const [team, setTeam] = useState([]);
  const [services, setServices] = useState([]);
  const [aboutHero, setAboutHero] = useState([]);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setIsMobile(window.screen.width < 768);
    });

    (async () => {
      const response = await getTeam();
      const result = await response.json();

      setTeam(result.data);
    })();
    (async () => {
      const response = await getServices();
      const result = await response.json();

      setServices(result.data);
    })();
    (async () => {
      const response = await getContact();
      const result = await response.json();

      setAboutHero(result.data[0]);
    })();
  }, []);

  return (
    <>
      <AboutSEO />
      <Hero isMobile={isMobile} aboutHero={aboutHero} />

      {team.length !== 0 && <People isMobile={isMobile} team={team} />}

      <CEO />

      {services.length !== 0 && (
        <Services isMobile={isMobile} services={services} />
      )}

      <Development isMobile={isMobile} />
    </>
  );
};

export default About;
